export class BrowseSettings {
	id:number;
	adminId:number;
	browse:string;
	selectedViewIndex:number;
	orderColumn:string;
	orderASC:boolean;
	recordLimit:number;
	metaData:string;

	constructor(data:any) {
		this.id = data.id;
		this.adminId = data.adminId;
		this.browse = data.browse;
		this.selectedViewIndex = data.selectedViewIndex;
		this.orderColumn = data.orderColumn;
		this.orderASC = data.orderASC;
		this.recordLimit = data.recordLimit;
		this.metaData = data.metaData;
	}

	getMetaDataValue(key:string):string|undefined{
		let val = this.metaData.split(";").find(s=>s.split(":")[0] == key);
		if (!val) return;
		let parts = val.split(":");
		parts.shift();
		return parts.join(":");
	}

	getBooleanOrNullValue(key: string): boolean | undefined {
		let value = this.getMetaDataValue(key);
		if (value !== "true" && value !== "false") {
			return undefined;
		}
		return value == "true";
	}

	getNumberValue(key:string, defaultValue:number = 0):number{
		let value = parseInt(this.getMetaDataValue(key) || "0");
		if (Number.isNaN(value)){
			return defaultValue;
		}
		return value;
	}
}